import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Person } from '@wdx/clmi/clmi-swagger-gen';
import { ApiPaginationService } from '@wdx/shared/infrastructure/api-service';
import { ConfigService } from '../../services/config.service';
import { Observable } from 'rxjs';

@Injectable()
export class PeopleService {
    private http = inject(HttpClient);
    private config = inject(ConfigService);
    private apiPaginationService = inject(ApiPaginationService);


    getForParty(partyId: string): Observable<Person> {
        return this.http.get<Person>(
            `${this.config.getConfiguration().API_BASE}/person/${partyId}`,
        );
    }

    getFavourites(): Observable<Person[]> {
        return this.http.get<Person[]>(
            `${this.config.getConfiguration().API_BASE}/person/favourite`,
        );
    }
}
